import styled from 'styled-components';
import {MinMaxBetAmountDefaultBox} from './min-max-bet-amount.default.box';
import {GAME_GROUP_LIVE_CASINO} from '../../../css-constants';

export const MinMaxBetAmountCisBox = styled(MinMaxBetAmountDefaultBox)`
    .${GAME_GROUP_LIVE_CASINO} & {
        color: ${({theme}) => theme.colors.brandSecondary};
    }
`;
